import 'swiper/components/pagination'

import React, { useRef, useState } from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import cn from 'classnames'
import dynamic from 'next/dynamic'
import { useMedia } from 'use-media'

import { data } from './data'

import 'swiper/swiper.scss'
import styles from './styles.module.scss'

const Swiper = dynamic(() => import('react-id-swiper'))

export const View = () => {
	const ref = useRef<any>(null)
	const [currentPage, setCurrentPage] = useState(0)
	const [currentSlide, setCurrentSlide] = useState(0)
	const isDesktop = useMedia({ minWidth: '1440px' })

	const goNext = () => {
		if (ref.current) {
			ref.current.slideNext()
			setCurrentSlide(ref.current.activeIndex)

			if (ref.current.activeIndex === 0) {
				setCurrentPage(0)
			}

			if (ref.current.activeIndex === 4) {
				setCurrentPage(4)
			}

			if (ref.current.activeIndex === 6) {
				setCurrentPage(6)
			}
		}
	}

	const goPrev = () => {
		if (ref.current) {
			ref.current.slidePrev()
			setCurrentSlide(ref.current.activeIndex)

			if (ref.current.activeIndex === 0) {
				setCurrentPage(0)
			}

			if (ref.current.activeIndex === 4) {
				setCurrentPage(4)
			}

			if (ref.current.activeIndex === 6) {
				setCurrentPage(6)
			}
		}
	}

	const goTo = (slide: 0 | 4 | 6) => {
		if (ref.current) {
			ref.current.slideTo(slide)
			setCurrentPage(slide)
		}
	}

	return (
		<Section className={styles.technologies} fullWidth>
			<svg
				width='540'
				height='1200'
				viewBox='0 0 540 1200'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<g clipPath='url(#clip0_5273:30022)'>
					<path
						d='M1124.2 1134.08C1124.2 1134.08 854.924 1097.58 784.617 1010.75C714.31 923.909 769.361 750.155 720.281 693.794C671.2 637.432 515.183 668.678 458.149 628.231C401.116 587.783 453.464 481.345 384.301 428.497C312.494 373.622 165.996 390.352 135.544 334.466C81.3229 234.974 196.119 121.181 106.091 49.9501C10.5603 -25.6376 -68.3689 59.2789 -144.641 0.260986'
						stroke='url(#paint0_linear_5273:30022)'
						strokeMiterlimit='10'
					/>
					<path
						d='M1101.66 1145C1101.66 1145 883.087 1116 792.671 1030.9C786.425 1025.01 780.722 1019.15 776.05 1012.95C704.818 918.596 760.339 762.415 710.776 702.567C662.345 644.392 511.087 675.839 451.918 638.322C438.818 630.018 431.053 618.387 425.705 604.775C404.759 551.452 426.427 484.745 376.436 442.711C369 436.514 360.945 431.098 352.398 426.55C281.649 388.525 163.352 400.705 129.655 354.275C119.614 340.476 113.997 325.566 110.731 310.214C93.1521 228.57 156.404 136.734 88.8812 76.5647C7.28777 3.85468 -67.4978 69.9529 -156.02 23.5363'
						stroke='url(#paint1_linear_5273:30022)'
						strokeMiterlimit='10'
					/>
					<path
						d='M1079.11 1155.94C1079.11 1155.94 874.182 1129.97 782.943 1033.34C777.219 1027.27 771.838 1021.37 767.453 1015.16C695.472 913.162 751.387 774.561 701.242 711.334C653.581 651.258 506.995 682.966 445.651 648.428C432.303 640.906 423.875 630.131 417.737 617.282C390.512 560.326 414.892 500.036 368.549 456.932C361.548 450.457 353.886 444.735 345.689 439.861C280.556 400.912 164.435 417 123.735 374.117C112.483 362.259 105.407 348.627 100.427 334.205C73.8382 257.192 130.911 163.897 71.6426 103.206C3.8254 33.7685 -66.6626 80.6536 -167.428 46.845'
						stroke='url(#paint2_linear_5273:30022)'
						strokeMiterlimit='10'
					/>
					<path
						d='M1056.56 1166.87C1056.56 1166.87 864.844 1144.43 773.277 1035.81C768.035 1029.59 763.022 1023.62 758.912 1017.38C686.395 907.56 742.431 786.821 691.757 720.1C644.758 658.211 502.986 690.039 439.446 658.486C425.844 651.733 416.639 641.876 409.825 629.75C375.866 569.313 403.419 515.314 360.711 471.146C354.155 464.379 346.888 458.339 339.036 453.131C279.419 413.487 166.062 432.981 117.872 393.906C105.535 383.908 96.8458 371.641 90.1785 358.156C54.4325 285.788 105.32 191.348 54.4458 129.794C0.137142 64.0906 -65.7856 91.3075 -178.801 70.1001'
						stroke='url(#paint3_linear_5273:30022)'
						strokeMiterlimit='10'
					/>
					<path
						d='M1034.02 1177.8C1034.02 1177.8 854.944 1159.39 763.577 1038.26C758.798 1031.93 754.206 1025.83 750.337 1019.59C677.532 901.812 733.26 799.195 682.252 728.874C635.768 665.299 498.996 697.059 433.234 668.571C419.398 662.548 409.323 653.694 401.919 642.237C360.778 578.595 391.945 530.566 352.879 485.314C346.769 478.278 339.897 471.942 332.389 466.422C278.167 426.269 168.05 448.487 112.015 413.714C98.6869 405.443 88.2777 394.675 79.937 382.114C34.9799 314.417 79.3747 219.214 37.2492 156.402C-3.98601 94.9078 -64.9016 101.975 -190.16 93.3687'
						stroke='url(#paint4_linear_5273:30022)'
						strokeMiterlimit='10'
					/>
					<path
						d='M1011.47 1188.74C1011.47 1188.74 844.374 1174.68 753.878 1040.73C749.527 1034.28 745.383 1028.05 741.768 1021.8C668.924 895.889 724.237 811.448 672.746 737.64C626.912 672.238 495.013 704.012 426.975 678.656C412.918 673.409 401.893 665.559 393.953 654.732C345.221 588.232 380.418 545.844 344.987 499.521C339.326 492.205 332.849 485.559 325.681 479.712C276.681 439.232 170.179 463.41 106.117 433.537C92.1296 427.12 79.6922 417.761 69.6547 406.099C15.3863 343.193 52.6855 247.495 20.0253 183.023C-8.79914 126.14 -64.0516 112.662 -201.547 116.657'
						stroke='url(#paint5_linear_5273:30022)'
						strokeMiterlimit='10'
					/>
					<path
						d='M988.919 1199.67C988.919 1199.67 833.055 1190.38 744.178 1043.18C655.302 895.983 717.63 827.302 663.241 746.407C608.852 665.513 435.945 727.91 385.988 667.219C321.31 588.593 381.971 551.291 318.974 493.003C265.729 443.715 126.186 491.45 59.3327 430.057C-53.9636 325.98 127.197 102.222 -212.967 139.939'
						stroke='url(#paint6_linear_5273:30022)'
						strokeMiterlimit='10'
					/>
				</g>
				<defs>
					<linearGradient
						id='paint0_linear_5273:30022'
						x1='489.782'
						y1='0.260986'
						x2='489.782'
						y2='1134.08'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#72CCFF' stopOpacity='0' />
						<stop offset='0.17705' stopColor='#72CCFF' />
						<stop offset='1' stopColor='#C2E9FF' stopOpacity='0' />
					</linearGradient>
					<linearGradient
						id='paint1_linear_5273:30022'
						x1='472.82'
						y1='23.5363'
						x2='472.82'
						y2='1145'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#72CCFF' stopOpacity='0' />
						<stop offset='0.17705' stopColor='#72CCFF' />
						<stop offset='1' stopColor='#C2E9FF' stopOpacity='0' />
					</linearGradient>
					<linearGradient
						id='paint2_linear_5273:30022'
						x1='455.843'
						y1='46.845'
						x2='455.843'
						y2='1155.94'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#72CCFF' stopOpacity='0' />
						<stop offset='0.17705' stopColor='#72CCFF' />
						<stop offset='1' stopColor='#C2E9FF' stopOpacity='0' />
					</linearGradient>
					<linearGradient
						id='paint3_linear_5273:30022'
						x1='438.88'
						y1='70.1001'
						x2='438.88'
						y2='1166.87'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#72CCFF' stopOpacity='0' />
						<stop offset='0.17705' stopColor='#72CCFF' />
						<stop offset='1' stopColor='#C2E9FF' stopOpacity='0' />
					</linearGradient>
					<linearGradient
						id='paint4_linear_5273:30022'
						x1='421.928'
						y1='93.3687'
						x2='421.928'
						y2='1177.8'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#72CCFF' stopOpacity='0' />
						<stop offset='0.17705' stopColor='#72CCFF' />
						<stop offset='1' stopColor='#C2E9FF' stopOpacity='0' />
					</linearGradient>
					<linearGradient
						id='paint5_linear_5273:30022'
						x1='404.962'
						y1='116.007'
						x2='404.962'
						y2='1188.74'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#72CCFF' stopOpacity='0' />
						<stop offset='0.17705' stopColor='#72CCFF' />
						<stop offset='1' stopColor='#C2E9FF' stopOpacity='0' />
					</linearGradient>
					<linearGradient
						id='paint6_linear_5273:30022'
						x1='387.976'
						y1='135.703'
						x2='387.976'
						y2='1199.67'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#72CCFF' stopOpacity='0' />
						<stop offset='0.17705' stopColor='#72CCFF' />
						<stop offset='1' stopColor='#C2E9FF' stopOpacity='0' />
					</linearGradient>
					<clipPath id='clip0_5273:30022'>
						<rect width='1337.25' height='1200' fill='white' transform='translate(-213)' />
					</clipPath>
				</defs>
			</svg>

			<div className={styles.container}>
				<div className={styles.technology}>
					<h2 className={styles.heading}>{data.technologies.heading}</h2>
					{data.technologies.content.map((el) => (
						<p className={styles.content} key={el}>
							{el}
						</p>
					))}
				</div>

				<div className={styles.images}>
					<div className={styles.technoImage}>
						<Image name={isDesktop ? 'technologies-desktop.png' : 'techologies.png'} />
					</div>
					<div className={styles.roundImage}>
						<Image name='ellipse.png' />
					</div>
				</div>

				<div className={styles.services}>
					<h2 className={styles.heading}>{data.services.heading}</h2>
					<div className={styles.servicesWrapper}>
						{data.services.content.map((el) => (
							<p className={styles.content} key={el}>
								{el}
							</p>
						))}
					</div>
				</div>

				<div className={styles.buttonWrapper}>
					<button
						onClick={goPrev}
						className={cn(styles.buttonNext, {
							[styles.buttonDisabled]: currentSlide === 0,
						})}
					>
						<Image name='arrow.png' />
					</button>
					<button
						onClick={goNext}
						className={cn(styles.buttonPrev, {
							[styles.buttonDisabled]: currentSlide === 6,
						})}
					>
						<Image name='arrow.png' />
					</button>
				</div>
				<div className={styles.slider}>
					<Swiper
						on={{
							init: (swiper) => {
								ref.current = swiper
							},
						}}
						spaceBetween={24}
						slidesPerView='auto'
						slideClass={styles.slide}
						breakpoints={{
							1024: {
								allowTouchMove: false,
							},
						}}
					>
						{data.slides.map((el) => (
							<div key={el.title}>
								<div className={styles.innerWrapper}>
									<div className={styles.slideHeading}>{el.title}</div>
									<div className={styles.slideBody}>{el.content}</div>
								</div>
							</div>
						))}
					</Swiper>
					<div className={styles.paginationContainer}>
						<button className={styles.paginationClickable} onClick={() => goTo(0)}>
							<div
								className={cn(styles.paginationButton, {
									[styles.paginationActive]: currentPage === 0,
								})}
							/>
						</button>
						<button className={styles.paginationClickable} onClick={() => goTo(4)}>
							<div
								className={cn(styles.paginationButton, {
									[styles.paginationActive]: currentPage === 4,
								})}
							/>
						</button>
						<button className={styles.paginationClickable} onClick={() => goTo(6)}>
							<div
								className={cn(styles.paginationButton, {
									[styles.paginationActive]: currentPage === 6,
								})}
							/>
						</button>
					</div>
				</div>
			</div>
		</Section>
	)
}
